import { useRef, useState, useEffect } from "react";
import styles from "./index.css";
import BannerContent from "./BannerContent";

import PropTypes from "prop-types";
import shouldEnableBanner from "./shouldEnableBanner";

const LoyaltyMembersDayBanner = ({
  categoryId,
  isMembersDayAvailable,
  membersDayEvent,
  storeCode
}) => {
  const bannerRef = useRef(null);

  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(
      shouldEnableBanner({
        categoryId,
        isMembersDayAvailable,
        membersDayEvent,
        storeCode
      })
    );
  }, [isMembersDayAvailable, membersDayEvent, storeCode]);

  const ContentComponent = BannerContent || (() => null);

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={styles.loyaltyMembersDayBanner} ref={bannerRef}>
      <ContentComponent membersDayEvent={membersDayEvent} />
    </div>
  );
};

LoyaltyMembersDayBanner.propTypes = {
  categoryId: PropTypes.string.isRequired,
  membersDayEvent: PropTypes.string,
  isMembersDayAvailable: PropTypes.boolean,
  storeCode: PropTypes.string
};

export default LoyaltyMembersDayBanner;
